import React, { useState } from 'react'
import styled from 'styled-components'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import CardContent from '../../../components/CardContent'
import CardIcon from '../../../components/CardIcon'
import Kira_Img from '../../../assets/img/BLOK.jpg'
import Label from '../../../components/Label'
import Value from '../../../components/Value'
import useReward from '../../../hooks/useReward'
import { getBalanceNumber } from '../../../utils/formatBalance'
import Spacer from '../../../components/Spacer'
import useIsOpen from '../../../hooks/useIsOpen'
import useIsEligibleForReward from '../../../hooks/useIsEligibleForReward'
import useEstimatedReward from '../../../hooks/useEstimatedReward'

interface HarvestProps {
  pid: number
}

const Harvest: React.FC<HarvestProps> = ({ pid }) => {
  const earnings = useEstimatedReward()  
  const isOpen = useIsOpen(pid)
  const isEligibleForReward = useIsEligibleForReward(pid);

  const [pendingTx, setPendingTx] = useState(false)
  const { onReward } = useReward(pid)

  return (
    <Card>
      <CardContent>
        <StyledCardContentInner>
          <StyledCardHeader>
            <CardIcon><img src={Kira_Img} height={50} /></CardIcon>
            <Value value={getBalanceNumber(earnings)} />
            <Label text="Current Reward" />
          </StyledCardHeader>
          <Spacer></Spacer>
          <Label text={'Available ' + getNextRewardDate()} />
          <StyledCardActions>
            <Button
              disabled={!isOpen || !isEligibleForReward || pendingTx}
              text={pendingTx ? 'Collecting...' : 'Collect Reward'}
              onClick={async () => {
                setPendingTx(true)
                await onReward()
                setPendingTx(false)
              }}
            />
          </StyledCardActions>
        </StyledCardContentInner>
      </CardContent>
    </Card>
  )
}

const getNextRewardDate = () => {
  let date = new Date();
  date = new Date(
    date.getMonth() == 11 ? date.getFullYear() + 1 : date.getFullYear(),
    date.getMonth() == 11 ? 0 : date.getMonth() + 1,
    2);
  return date.toDateString()
}

const StyledCardHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`
const StyledCardActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${(props) => props.theme.spacing[6]}px;
  width: 100%;
`

const StyledSpacer = styled.div`
  height: ${(props) => props.theme.spacing[4]}px;
  width: ${(props) => props.theme.spacing[4]}px;
`

const StyledCardContentInner = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`

export default Harvest
